var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagFacilityIconWater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.37305C8 1.37305 3.5 6.31992 3.5 9.81992C3.5 12.5812 5.23875 14.3199 8 14.3199C10.7613 14.3199 12.5 12.5812 12.5 9.81992C12.5 6.31992 8 1.37305 8 1.37305ZM8.5 12.6949V11.9449C8.9971 11.9443 9.47368 11.7466 9.82519 11.3951C10.1767 11.0436 10.3744 10.567 10.375 10.0699H11.125C11.1243 10.7659 10.8475 11.4331 10.3553 11.9253C9.86321 12.4174 9.19596 12.6942 8.5 12.6949Z",
    fill: "#F56600"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagFacilityIconWater);
export default __webpack_public_path__ + "static/media/Tag-Facility-icon-water.55cb855e7c6dc991c3afaaed9e85e252.svg";
export { ForwardRef as ReactComponent };